
import * as GlobalTypes from "../../types";
import { Catalog, CatalogItem } from "./common";

export type HeaterCatalog = Catalog & {
    heaters:HeaterFamily[];
}

export type HeaterFamily = CatalogItem & {
    deviceType:HeaterDeviceTypes;
    supportsHeating:GlobalTypes.BoolStrings;
    supportsCooling:GlobalTypes.BoolStrings;
    minAirOperatingTempF:GlobalTypes.NumberOrString;
    maxAirOperatingTempF:GlobalTypes.NumberOrString;
    flowVolumeMinGpm:GlobalTypes.NumberOrString;
    flowVolumeMaxGpm:GlobalTypes.NumberOrString;
    efficiency:string;
    busIdMin:GlobalTypes.NumberOrString;
    busIdMax:GlobalTypes.NumberOrString;
    powerInfo:GlobalTypes.PowerInfo;
    fuelInfo:GlobalTypes.FuelInfo;
}

export enum HeaterDeviceTypes {
    HEATER = 'HEATER',
    HEATPUMP = 'HEATPUMP',
    CHILLER = 'CHILLER',
}
